// @flow
import type { Element } from 'react';

import React from 'react';
import indicator from 'ordinal/indicator.js';
import {
  PERIOD_1_DIR_1,
  PERIOD_1_DIR_2,
  PERIOD_2_DIR_1,
  PERIOD_2_DIR_2,
  PERIOD_3_DIR_1,
  PERIOD_3_DIR_2,
} from '@hbrisk/sp3-risk-model-support/models/app/attributes/names/index.js';
import Tip from '#components/support/tooltips/Tip/index.jsx';
import { Field, FormGroup } from '#components/pages/Models/Model/support/form/index.js';

const periodFields = {
  '1': [PERIOD_1_DIR_1, PERIOD_1_DIR_2],
  '2': [PERIOD_2_DIR_1, PERIOD_2_DIR_2],
  '3': [PERIOD_3_DIR_1, PERIOD_3_DIR_2],
};

type Props = {|
  fieldsByName: Object,
  form: string,
  period: 1 | 2 | 3,
|};

const PeriodRow = ({ fieldsByName, form, period }: Props): Element<typeof FormGroup> => {
  const [dir1Field, dir2Field] = periodFields[period];
  return (
    <FormGroup tag="tr" form={form} fields={[dir1Field, dir2Field]}>
      <td className="text-nowrap">
        {period}
        {indicator(period)} Mode Period (T
        <sub>{period}</sub>) <Tip tipId={`period${period}`} />
      </td>
      <td>
        <Field field={fieldsByName[dir1Field]} excludeLabel />
      </td>
      <td>
        <Field field={fieldsByName[dir2Field]} excludeLabel />
      </td>
    </FormGroup>
  );
};

export default PeriodRow;
